export const CasemasterAssessmentStates = {
  FULL_SCREEN_PERMISSION: 'full_screen_permission',
  FETCHING_CASEMASTER_PROBLEM: 'fetching_casemaster_problem',
  SHOWING_TUTORIAL: 'showing_tutorial',
  STARTING: 'starting',
  RUNNING: 'running',
  FINISHING: 'finishing',
  FINISHED: 'finished'
};

export const QuestionStates = {
  AI_SPEAKING: 'ai_speaking',
  USER_ANSWERING: 'user_answering',
  WAITING: 'waiting',
  RECORDING: 'recording',
  RECORDED: 'recorded',
  ANALYZING: 'analyzing',
};

export const InterviewerStates = {
  SPEAKING: 'speaking',
  LISTENING: 'listening',
};

export const QuestionsTypes = {
  CASE_INTRO: 'case_intro',
  CASE_ANALYSIS: 'case_analysis',
  FOLLOW_UP_1: 'followup1',
  FOLLOW_UP_2: 'followup2'
};

// Audio cues for case master interviews
export const getRandomAudioCue = (type) => {
  const audioCues = {
    "Case_Intro_Cues": [
      {
        text: "Let's start with this business case. Please read through it carefully and then I'll ask you some questions.",
        audioUrl: "https://assets.languify.in/audio/case_intro_1.mp3"
      }
    ],
    "Case_Analysis_Cues": [
      {
        text: "Now, I'd like you to walk me through your analysis of this case. What are your initial thoughts?",
        audioUrl: "https://assets.languify.in/audio/case_analysis_1.mp3"
      }
    ],
    "Followup_Intro_Cues": [
      {
        text: "Interesting perspective. Let me ask you a follow-up question.",
        audioUrl: "https://assets.languify.in/audio/followup_intro_1.mp3"
      }
    ],
    "Case_Timeout_Cues": [
      {
        text: "You have one minute remaining for your response.",
        audioUrl: "https://assets.languify.in/audio/case_timeout_1.mp3"
      }
    ]
  };

  const cues = audioCues[type] || [];
  return cues[Math.floor(Math.random() * cues.length)] || { text: "", audioUrl: "" };
};

// Case Master specific tour steps
export const CaseMasterTourSteps = [
  {
    id: "interviewer",
    message: "Your interviewer appears here. They will guide you through the case study by asking questions and listening to your analysis.",
    skipText: "Skip tour",
    action: "Next",
    hideClose: true,
    data: {},
    tipNumber: 1,
    totalTip: 4
  },
  {
    id: "interviewee",
    message: "This is your camera preview. Make sure you're well-positioned and visible throughout the interview.",
    skipText: "Skip tour",
    action: "Next",
    hideClose: true,
    data: {},
    tipNumber: 2,
    totalTip: 4
  },
  {
    id: "case-timer",
    message: "Keep track of your time here. You have 30 minutes to complete the case study interview.",
    skipText: "Skip tour",
    action: "Next",
    hideClose: true,
    data: {},
    tipNumber: 3,
    totalTip: 4
  },
  {
    id: "answer-section",
    message: "Click 'Record answer' to respond to the case questions. Speak clearly and provide structured analysis. Your answer will auto-save after 2 minutes.",
    skipText: "Skip tour",
    action: "Got it!",
    hideClose: true,
    data: {},
    tipNumber: 4,
    totalTip: 4
  }
];

// Analysis Phases for Case Master Assessment
export const AnalysisPhases = {
  Preparing_Analysis: {
    name: "Preparing Analysis",
    images: "https://languify-assets-v02.s3.ap-south-1.amazonaws.com/images/analysis4C.png",
    messages: [
      { message: "Capturing your case study breakdown", duration: 8000 },
      { message: "Analyzing your business insights", duration: 7000 },
      { message: "Reviewing your problem-solving approach", duration: 8000 },
      { message: "Evaluating your strategic thinking", duration: 7000 },
      { message: "Assessing your communication clarity", duration: 8000 },
      { message: "Recording your analytical framework", duration: 7000 }
    ]
  },
  Evaluating_Performance: {
    name: "Evaluating Performance",
    images: "https://languify-assets-v02.s3.ap-south-1.amazonaws.com/images/evaluating4c.png",
    messages: [
      { message: "Analyzing your structured thinking", duration: 7000 },
      { message: "Evaluating depth of analysis", duration: 7000 },
      { message: "Assessing business acumen", duration: 8000 },
      { message: "Reviewing quantitative reasoning", duration: 7000 },
      { message: "Checking hypothesis-driven approach", duration: 8000 },
      { message: "Measuring communication effectiveness", duration: 8000 }
    ]
  },
  Finalizing_Feedback: {
    name: "Finalizing Feedback",
    images: "https://languify-assets-v02.s3.ap-south-1.amazonaws.com/images/finalizing.png",
    static: [
      { message: "Finalizing actionable insights", duration: 10000 },
      { message: "Highlighting your strengths", duration: 10000 },
      { message: "Identifying growth areas", duration: 10000 },
      { message: "Packaging into your personalized report", duration: 10000 }
    ],
    loop: [
      { message: "Finalizing a report that guides your next step", duration: 1000 },
      { message: "Hold tight… we're nearly finished!", duration: 1000 }
    ]
  },
  Completed: {
    name: "Completed",
    images: "https://languify-assets-v02.s3.ap-south-1.amazonaws.com/images/completed4c.png",
    messages: [
      { message: "Your feedback report is ready.", duration: null }
    ]
  }
};
